module.exports = __webpack_public_path__ + "static/edinme-sm-11577fa9ea1f39366e843d7261521e1e.png";